import Reveal from "@/components/landing/Reveal";
import { renderTitle, toFullUrl } from "@/components/landing/utils";

export default function GallerySection({ block }) {
  const items = block?.items || [];
  if (!items.length) return null;
  return (
    <section className="section-dark py-24 md:py-32 relative overflow-hidden">
      <div className="max-w-[1300px] mx-auto px-6 lg:px-10">
        <div className="max-w-3xl mb-12">
          <Reveal><span className="eyebrow">Evidencia visual</span></Reveal>
          <Reveal delay={120}>
            <h2 className="mt-4 font-display text-4xl md:text-5xl text-[#0A0A0A]">
              {renderTitle(block?.title || "Producto real. Sucursales <em>reales</em>.")}
            </h2>
          </Reveal>
          {block?.subtitle && (
            <Reveal delay={220}>
              <p className="mt-4 text-[#3F3F46] text-base leading-relaxed">{block.subtitle}</p>
            </Reveal>
          )}
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
          {items.slice(0, 8).map((g, i) => {
            const img = toFullUrl(g.image_url);
            return (
              <Reveal key={i} delay={i * 60}>
                <div className={`glass overflow-hidden ${i % 5 === 0 ? "md:col-span-2 md:row-span-2 aspect-square" : "aspect-square"} group`}>
                  {img ? (
                    <img loading="lazy" decoding="async" src={img} alt="" className="w-full h-full object-cover opacity-90 group-hover:opacity-100 group-hover:scale-105 transition-all duration-700" />
                  ) : (
                    <div className="w-full h-full bg-gradient-to-br from-[#0F0F13] to-[#1A1A22]" />
                  )}
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
